import { useQuery } from '@tanstack/react-query'
import { accountKeys } from '../../../../data/queryFactories'
import {
  showErrorToast,
  
} from '../../../../utils/showToast'
import { accountService } from '../../../../service/AccountService'
import { convertUnixToDate } from '../../../../utils/conversion'

function mapUserData(data) {
  return {
    uuid: data.uuid || null,
    schoolId: data.schoolId || null,
    fullName: data.fullName || null,
    accountType: data.accountType || null,
    studentCourse: data.studentCourse || null,
    groupUuids: (data?.groups ?? []).map((item) => {
      return {
        uuid: item.uuid,
        name: item.name,
      }
    }),
    schoolEmail: data.schoolEmail || null,
    personalEmail: data.personalEmail || null,
    phoneNumber: data.phoneNumber || null,
    className: data.className || null,
    faculty: data.faculty || null,
    school: data.school || null,
    devices: data?.devices ?? [],
    books: data?.books ?? [],
    status: data.status || null,
    totalPayment: data.totalPayment || 0,
    joinDate: convertUnixToDate(data.joinDate),
  }
}

export default function useGetAccountByUUID(uuid) {
  const { data, isLoading, error } = useQuery({
    queryKey: accountKeys.detail(uuid),
    queryFn: async () => {

      const { success, message } = await accountService.getByUuid(uuid)
      if (!success) {
        throw new Error('Lỗi: Không thể lấy dữ liệu người dùng')
      }
      const userData = message?.content
      if (userData) {
        return mapUserData(userData)
      }

      throw new Error('Không tìm thấy thông tin người dùng')
    },
  })

  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại vui lòng liên hệ admin'
    })
  }

  return { data, isLoading, error }
}
